import React from 'react';
import GoogleLogin from "react-google-login";
import { useNavigate } from "react-router-dom";
import { FcGoogle } from "react-icons/fc";
import mediaVideo from '../../assets/media.mp4';
import logo from '../../assets/logowhite.png';
import {client} from "../../client";
import {HOME} from "../../constants/routes";
import { loginStyle } from '../../styles/loginStyle';

const SIGN_IN_GOOGLE = 'Sign in with Google';
const LOGO_WIDTH = '300px';

const renderItem = (renderProps) => (
    <button type="button"
            className={loginStyle.button}
            onClick={renderProps.onClick}
            disabled={renderProps.disabled}
    >
        <FcGoogle className="mr-4" />
        {SIGN_IN_GOOGLE}
    </button>
)

const Login = () => {
    const navigate = useNavigate();

    const responseGoogle = (response) => {
        const { profileObj } = response;
        const { name, googleId, imageUrl } = profileObj;

        localStorage.setItem('user', JSON.stringify(profileObj));
        const document = {
            _id: googleId,
            _type: 'user',
            userName: name,
            image: imageUrl,
        }

        client.createIfNotExists(document)
            .then(() => {
                navigate(HOME, {replace: true});
            })
            .catch(error => console.log(error));
    }

    return (
        <div className={loginStyle.login}>
            <div className={loginStyle.container}>
                <video src={mediaVideo}
                       type="video/mp4"
                       loop
                       controls={false}
                       muted
                       autoPlay
                       className={loginStyle.video} />
                <div className={loginStyle.googleContainer}>
                    <div className="p-5">
                        <img src={logo} width={LOGO_WIDTH} alt="logo" />
                    </div>
                    <div className="shadow-2xl">
                        <GoogleLogin
                            clientId={process.env.REACT_APP_GOOGLE_API_TOKEN}
                            render={renderItem}
                            onSuccess={responseGoogle}
                            onFailure={responseGoogle}
                            cookiePolicy="single_host_origin" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;
